// The specialist-call booking claim's verification tier (`meetings` table,
// migration 0182) — the vocabulary shared by the Explorer project table's
// Meeting column/filter and a project's own Meetings tab, so the badge and
// the filter option read identically wherever a claim shows up.
//
// A claim is not a confirmation. `unverifiable` (HubSpot desks, `sales`/`bsm`:
// no token, no read-back, ever) and `pending` (a Calendly `sourcing` claim,
// awaiting reconciliation) both mean "the buyer pressed Confirm, and that is
// all we know"; only a vendor read can ever move a row to `confirmed` or
// `canceled` — see `recruiter/repo/meetings.py`'s module docstring.

export const MEETING_VERIFICATION_TIERS = [
  "unverifiable",
  "pending",
  "confirmed",
  "canceled",
] as const;

export type MeetingVerification = (typeof MEETING_VERIFICATION_TIERS)[number];

export const MEETING_VERIFICATION_TONE: Record<
  string,
  "success" | "warning" | "danger" | "neutral"
> = {
  confirmed: "success",
  pending: "warning",
  unverifiable: "neutral",
  canceled: "danger",
};

export const MEETING_VERIFICATION_LABEL: Record<string, string> = {
  unverifiable: "Unverifiable",
  pending: "Pending",
  confirmed: "Confirmed",
  canceled: "Canceled",
};

/** The label for the Explorer filter's `none` bucket / a row with no claim. */
export const NO_MEETING_LABEL = "No meeting";
